/**
 * NavItem Component
 *
 * Элемент навигации портала с поддержкой collapsed режима
 * Используется в Sidebar для элементов меню
 */

import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Box, Group, Text, Tooltip } from '@mantine/core';
import tokens from '../theme/designTokens';

const NavItem = ({ icon, label, to, collapsed = false, onClick }) => {
  const location = useLocation();
  const active = to && location.pathname === to;

  const handleClick = () => {
    if (onClick) onClick();
  };

  const content = (
    <Box
      onClick={handleClick}
      style={{
        position: 'relative',
        padding: collapsed ? '12px' : '12px 16px',
        cursor: 'pointer',
        backgroundColor: active ? tokens.colors.semantic.info.background : 'transparent',
        borderLeft: active ? `4px solid ${tokens.colors.brand.primary}` : '4px solid transparent',
        transition: 'all 0.2s ease',
        display: 'flex',
        justifyContent: collapsed ? 'center' : 'flex-start',
        alignItems: 'center',
      }}
      onMouseEnter={(e) => {
        if (!active) {
          e.currentTarget.style.backgroundColor = tokens.colors.neutral[2];
        }
      }}
      onMouseLeave={(e) => {
        if (!active) {
          e.currentTarget.style.backgroundColor = 'transparent';
        }
      }}
    >
      {collapsed ? (
        <Box style={{ color: active ? tokens.colors.brand.primary : tokens.colors.neutral[7] }}>
          {icon}
        </Box>
      ) : (
        <Group gap="md" wrap="nowrap">
          <Box style={{ color: active ? tokens.colors.brand.primary : tokens.colors.neutral[7] }}>
            {icon}
          </Box>
          <Text
            size="sm"
            fw={active ? 600 : 400}
            style={{
              color: active ? tokens.colors.brand.primary : tokens.colors.neutral[8],
            }}
          >
            {label}
          </Text>
        </Group>
      )}
    </Box>
  );

  const wrappedContent = to ? (
    <Link to={to} style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
      {content}
    </Link>
  ) : (
    content
  );

  return collapsed ? (
    <Tooltip label={label} position="right" withArrow>
      {wrappedContent}
    </Tooltip>
  ) : (
    wrappedContent
  );
};

export default NavItem;
